import {
  QueryPermanentShopPageOutput,
  SoldOutHeaderInterface,
} from 'types/types';
import { shopLayoutConfig } from './constants';
import { prepProductListing } from 'components/_shared/widgets/product-listing/utils';
import { ShopPageInterface } from './types';

/**
 * Data/props preparation.
 */
export const shopPageProps: (
  data: QueryPermanentShopPageOutput
) => ShopPageInterface = ({
  permanentShopProducts,
  banners,
  promoBlocks,
  permanentShop: { id },
  configs,
}) => {
  const layoutConfig = shopLayoutConfig[id] || shopLayoutConfig.default;

  return {
    items: prepProductListing({
      products: permanentShopProducts,
      promoBlocks,
      withHero: layoutConfig.withHero,
      canAddPromoBockToHeroGallery: true,
      withShops: true,
      gallerySize: layoutConfig.gallerySize,
      maxGalleriesPerShop: layoutConfig.maxGalleriesPerShop,
      galleryLayouts: layoutConfig.layout,
      accentFirstRow: layoutConfig.accentFirstRow,
      soldOutHeaders: configs?.soldOutOverlay,
    }),
    banner: banners,
  };
};
